import React, { useState, useEffect } from "react";
import {
  TextField,
  IconButton,
  InputAdornment,
  MenuItem,
} from "@mui/material";
import { ArrowForward, Close } from "@mui/icons-material";

const RubricsSearch = ({ onSearchResult, rubrics }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [filterBy, setFilterBy] = useState("all");
  const [isSearched, setIsSearched] = useState(false); // tracks if user has searched

  const handleSearch = (e) => {
    e?.preventDefault();

    if (!searchQuery.trim()) {
      onSearchResult(null);
      setIsSearched(false);
      return;
    }

    setIsSearching(true);

    setTimeout(() => {
      if (!Array.isArray(rubrics)) {
        onSearchResult(null);
        setIsSearching(false);
        return;
      }

      const query = searchQuery.trim().toLowerCase();

      const results = rubrics.filter((r) => {
        const name = String(r.name || "").toLowerCase();
        const subject = String(r.subject || "").toLowerCase();
        const standard = String(r.standard || "").toLowerCase();
        const createdBy = String(r.createdBy || "").toLowerCase();
        const startDate = String(r.startDate || "").toLowerCase();

        switch (filterBy) {
          case "standard":
            return standard.includes(query);
          case "subject":
            return subject.includes(query);
          case "createdBy":
            return createdBy.includes(query);
          case "name":
            return name.includes(query);
          case "all":
          default:
            return (
              name.includes(query) ||
              subject.includes(query) ||
              standard.includes(query) ||
              createdBy.includes(query) ||
              startDate.includes(query)
            );
        }
      });

      onSearchResult(results.length > 0 ? results : []);
      setIsSearching(false);
      setIsSearched(true); // show cross after clicking arrow
    }, 300);
  };

  const handleClear = () => {
    setSearchQuery("");
    setFilterBy("all");
    setIsSearched(false);
    onSearchResult(null);
  };

  // 🔹 When typing again, immediately revert back to Arrow
  useEffect(() => {
    if (searchQuery.trim().length > 0) {
      setIsSearched(false);
    }
  }, [searchQuery]);

  return (
    <form
      onSubmit={handleSearch}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
      }}
    >
      {/* Filter dropdown */}
      <TextField
        select
        size="small"
        value={filterBy}
        onChange={(e) => setFilterBy(e.target.value)}
        sx={{ width: 150 }}
      >
        <MenuItem value="all">All</MenuItem>
        <MenuItem value="name">Name</MenuItem>
        <MenuItem value="subject">Subject</MenuItem>
        <MenuItem value="standard">Standard</MenuItem>
        <MenuItem value="createdBy">Created By</MenuItem>
      </TextField>

      {/* Search field */}
      <TextField
        variant="outlined"
        size="small"
        placeholder="Search..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        sx={{
          width: 220,
          "& .MuiOutlinedInput-root": {
            height: "36px",
            borderRadius: "18px",
          },
          "& .MuiInputBase-input": {
            padding: "8px 14px",
          },
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {isSearched ? (
                <IconButton onClick={handleClear} edge="end" size="small">
                  <Close fontSize="small" />
                </IconButton>
              ) : (
                <IconButton
                  type="submit"
                  edge="end"
                  size="small"
                  disabled={!searchQuery.trim() || isSearching} // disabled if empty
                >
                  <ArrowForward fontSize="small" />
                </IconButton>
              )}
            </InputAdornment>
          ),
        }}
      />
    </form>
  );
};

export default RubricsSearch;
